// extracted by mini-css-extract-plugin
export const iconWrapper = "styles-module--icon-wrapper--CzeG0";
export const icon = "styles-module--icon--1-_Oo";
export const customIcon = "styles-module--custom-icon--2rT-0";